import React from "react";
import { motion } from "framer-motion";
import './stek.css';
import { stekData } from './data'

export default function StekBlock() {
    return(
        <div className="container">
            <h4>Наш стек</h4>
            <div className="stekWrapper">
                {stekData.map((item) => (
                    <motion.div 
                        className="stekBox"
                        initial={{ scale: 1 }}
                        whileHover={{
                            scale: 1.05,
                            boxShadow: "0px 4px 8px 4px #00000040",
                            transition: { 
                                duration: 0.3,
                                ease: "easeOut"
                            }
                        }}
                        whileTap={{ scale: 0.98 }} 
                        key={item.id}
                    >
                        <p>{item.text}</p>
                    </motion.div>
                ))}
            </div>
        </div>
    )
}